<template lang="html">
  <div class="create-draft">
    <h1>Create Draft</h1>
    <p>
      After you create your draft, you will be able to invite
      everyone else from your league.
    </p>

    <br />

    <form @submit.prevent="create" v-if="loaded">
      <div class="setting">
        <h4>Let's give this draft a name</h4>
        <input
          type="text"
          required
          maxlength="20"
          placeholder="League name"
          v-model="draftForm.name"
        >
      </div>

      <div class="setting">
        <h4>How many rounds in the draft?</h4>
        <multiselect v-model="draftForm.rounds" :options="roundOptions" />
      </div>

      <div class="setting">
        <h4>What kind of draft is this?</h4>
        <multiselect v-model="draftForm.type" :options="typeOptions" label="label"  />
      </div>

      <div class="setting">
        <h4>How many teams?</h4>
        <multiselect v-model="draftForm.numTeams" :options="teamOptions" />
      </div>

      <div class="setting">
        <h4>How many seconds for each pick?</h4>
        <multiselect v-model="draftForm.duration" :options="durationOptions" />
      </div>

      <div class="setting">
        <h4>What rankings do you want to use as the default?</h4>
        <multiselect v-model="draftForm.baseRanking" :options="baseRankingOptions" label="label" />
      </div>

      <button type="submit" :disabled="disableSubmit">Create</button>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      draftForm: {
        name: '',
        rounds: 16,
        type: { label: 'Snake', value: 'snake' },
        numTeams: 10,
        baseRanking: null,
        duration: 90,
      },
      running: false,
      loaded: false,
    };
  },

  computed: {
    ...mapState({
      teamOptions: ({ draft }) => draft.teamOptions,
      durationOptions: ({ draft }) => draft.durationOptions,
      typeOptions: ({ draft }) => draft.typeOptions,
      roundOptions: ({ draft }) => draft.roundOptions,
    }),

    ...mapGetters({
      baseRankingOptions: 'rankings/baseRankingOptions',
    }),

    disableSubmit() {
      return this.running || !this.draftForm.baseRanking;
    },
  },

  watch: {
    baseRankingOptions(value) {
      [this.draftForm.baseRanking] = value;
    },
  },

  created() {
    this.load();
  },

  methods: {
    create() {
      this.running = true;

      this.$store.dispatch('draft/CREATE_DRAFT', this.draftForm)
        .then((id) => {
          this.$router.push(`/draft/${id}`);
        });
    },

    load() {
      this.$store.dispatch('rankings/LOAD_BASE_RANKINGS')
        .then(() => {
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .create-draft {
    @include container;
    padding-bottom: $gp * 3;
  }

  .setting {
    margin-bottom: $gp * 2;
  }

  .team {
    display: flex;
    align-items: center;
    margin-bottom: $gp;

    @media($small) {
      display: block;
      margin-bottom: $gp * 2;
    }
  }

  .team-name {
    @media($medium) {
      margin-right: $gp;
    }
  }
</style>
